import { createContext } from "react";

import type { MainClassNameContextValue } from "./chromeTypes";

export const MainClassNameContext =
  createContext<MainClassNameContextValue | null>(null);
MainClassNameContext.displayName = "MainClassNameContext";
